import { round } from "lodash";
import pluralize from "pluralize";

interface TooltipParam {
  name: string;
  seriesName: string;
  value: number;
  color: string;
  dimensionNames?: string[];
  encode?: {
    x: number[];
    y: number[];
  };
  axisValue?: string;
  marker?: string;
  componentSubType?: string;
  componentType?: string;
  dataIndex?: number;
  data?: any;
}

export const formatTooltip = (params: TooltipParam | TooltipParam[]): string => {
  // Handle both single item and array of items
  const paramsArray = Array.isArray(params) ? params : [params];
  if (!paramsArray || paramsArray.length === 0) {
    return "";
  }

  // Get the channel name from the first param
  const channelName = paramsArray[0]?.axisValue || paramsArray[0]?.name;

  // Find both Length and Peak values for this channel
  let lengthValue: number | undefined;
  let lengthColor: string | undefined;
  let peakValue: number | undefined;
  let peakColor: string | undefined;

  // First check the current params
  paramsArray.forEach((param) => {
    if (param.seriesName === "Length") {
      lengthValue = param.value;
      lengthColor = param.color;
    } else if (param.seriesName === "Peak") {
      peakValue = param.value;
      peakColor = param.color;
    }
  });

  // Build the tooltip content
  let values = "";

  if (lengthValue !== undefined) {
    values += `
    <div style="margin-top: 12px;">
      <div style="font-weight: bold; font-size: 14px; padding-bottom: 4px;">
        <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background-color: ${lengthColor}; margin-right: 4px;"></span>
        Length
      </div>
      <div style="font-weight: 200; font-size: 16px">${round(lengthValue, 1)} ${pluralize("week", lengthValue)}</div>
    </div>`;
  }

  if (peakValue !== undefined) {
    values += `
    <div style="margin-top: 12px;">
      <div style="font-weight: bold; font-size: 14px; padding-bottom: 4px;">
        <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background-color: ${peakColor}; margin-right: 4px;"></span>
        Peak
      </div>
      <div style="font-weight: 200; font-size: 16px">${round(peakValue, 1)} ${pluralize("week", peakValue)}</div>
    </div>`;
  }

  return `
  <div style="font-size: 20px; font-weight: 600; margin-bottom: 8px;">${channelName}</div>
  <div style="height: 1px; background-color: #E5E5E5; margin-top: 18px;"></div>
  ${values}`;
};
